<template>
    <div class="profile-card text-decoration-none">
      <div
        class="video-card"
      >
        <div class="thumbnail-wrapper" style="cursor: pointer;" @click="$emit('view', profile)">
          <!-- Thumbnail -->
          <img
            :src="locked ? profile.blur_image || profile.image : profile.image"
            class="thumbnail"
            :class="{ blurred: locked }"
          />
  
          <!-- Subscribe -->
          <div v-if="locked" class="subscribe-wrapper">
          <button
            class="subscribe-btn"
            @click.stop="$emit('subscribe', profile)"
          >
            Subscribe
          </button>

          <button
            class="pay-text"
            @click.stop="$emit('subscribe', profile)"
          >
           <span> or pay {{ profile.dayruns_token }}{{token_label}}</span>
          </button>
        </div>
        </div>
        
        <div class="video-info">
          <h4 class="title">{{ toSentenceCase(truncateWords(profile.title, 10)) }}</h4>
  
          <div class="meta">
            <span class="chat-icon">
              <!-- <img :src="chat" class="phone-location-ico" /> -->
            </span>
            <span class="view-icon">
              <img :src="view" class="phone-location-ico"  @click.stop="$emit('likeImage', profile)"/>
              {{ profile.likes }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import view from "@/assets/carbon_view-filled.png";
import chat from "@/assets/mynaui_chat-dots-solid.png";

export default {
  name: "ModelPaidPictureCard",
  props: {
    profile: {
      type: Object,
      required: true
    },
    locked: {
    type: Boolean,
    default: false
  }
  },

  methods: {
  toSentenceCase(text) {
      if (!text) return '';
      return text
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
  },

  truncateWords(text, charLimit) {
    if (!text) return "";
      if (text.length <= charLimit) return text;
      return text.substring(0, charLimit).trim() + "…";
    },
  },

  data() {
  return {
    view,
    chat,
    isHovering: false,
    token_label: process.env.VUE_APP_TOKEN_LABEL,
  };
}
};
</script>

<style lang="scss" scoped>
.phone-location-ico{
  cursor: pointer;
}
.video-card {
  background: #0f0f1a;
  border-radius: 0px;
  overflow: hidden;
  color: #fff;
}
.thumbnail-wrapper {
  position: relative;
}

.thumbnail-wrapper img {
  width: 100% !important;
  height: 199px;
  object-fit: cover;
  border-radius: 0px;
}

.thumbnail {
  width: 100%;
  height: 260px;
  object-fit: cover;
  transition: filter 0.3s ease;
  }

  .thumbnail,
  .preview-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .preview-video {
    position: absolute;
    top: 0;
    left: 0;
  }

  /* Locked blur effect */
  .thumbnail.blurred {
  filter: blur(8px);
  transform: scale(1.05); /* avoids edge transparency */
  }


.play-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-btn {
  width: 45px;
  height: 45px;
  background: #fff;
  color: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0,0,0,.7);
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 4px;
}
.subscribe-wrapper {
    position: absolute;        /* keeps it over the thumbnail */
    bottom: 40px;              /* distance from bottom */
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}
.subscribe-btn {
  position: absolute;
  bottom: 55px;
  left: 50%;
  transform: translateX(-50%);
  background: #ff4f8b;
  border: none;
  color: #fff;
  padding: 4px 2px;
  border-radius: 6px;
  font-size: 12px;
  width: 120px;
}
.pay-text {
    margin-top: -40px;
    font-size: 12px;
    font-weight: bold;
    color: #000;
    opacity: 0.9;
    text-align: center;
}
.video-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px 0 4px;

  .title {
    font-size: 14px !important;
    margin: 0 0 6px;
  }
}

.meta {
  display: flex;
  gap: 10px;
  font-size: 12px;
  opacity: 0.7;
}
.chat-icon img{ 
  width: 16px;
  height: 16px;
}
.view-icon {
    cursor: pointer;
}
.view-icon img{
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* 📱 Mobile */
@media (max-width: 768px) {

.thumbnail-wrapper img {
  height: 180px;
}
.video-info {
  padding: 4px;

  .title {
    font-size: 10px !important;
    font-weight: 550;
    margin: 0 0 6px;
    }
}

.meta {
  gap: 5px;
  font-size: 11px;
  opacity: 0.7;
}
.chat-icon img{ 
  width: 13px;
  height: 13px;
}
.view-icon img{
  width: 13px;
  height: 13px;
}
.subscribe-btn {
  bottom: 45px;
  left: 50%;
  transform: translateX(-50%);
  background: #ff4f8b;
  border: none;
  color: #fff;
  padding: 4px 0px;
  border-radius: 6px;
  font-size: 11px;
  width: 100px;
}

.play-overlay {
  margin-top: -40px;
}
}

</style>
